import {management} from '../../../index.js' //api
import {RainfallRepository} from '../../infra/knex/repositories/rainfall'
import {SaveRainfallUseCase}from "./saveRainfall"
// const {SaveRainfallController}=require("./saveRainfallController")

// module.exports=()=>{
//     const useCase=new SaveRainfallUseCase(new RainfallRepository(management))
//     const controller=new SaveRainfallController(useCase)
//     return controller
// }
export const saveRainfallUseCase=new SaveRainfallUseCase(new RainfallRepository(management))
